import React from 'react';

function DataFilterActive() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 48 48'>
      <path
        fill='green'
        d='M24 .3C10.898.3.3 10.899.3 24 .3 37.102 10.899 47.7 24 47.7 37.102 47.7 47.7 37 47.7 24S37.101.398 24 .3zm11.102 19.2l-11.5 11.7a1.976 1.976 0 01-1.403.6c-.5 0-1-.198-1.3-.5l-6.5-5.902c-.797-.699-.899-2-.098-2.796.699-.801 2-.903 2.8-.102l5.098 4.602 10.2-10.403c.8-.8 2-.8 2.8 0 .7.7.7 2-.097 2.801zm0 0'
      />
    </svg>
  );
}

export default DataFilterActive;
